import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const RequireAuth = ({ children }) => {
  const { userId } = useAuth();

  if (!userId) {
    return <Navigate to="/" />;
  }

  return children;
};

export default RequireAuth;
